// 휴대폰에서 터진 화면 오류를 Firestore clientErrors에 남긴다 — 개발 화면에서 재현 안 되는 고장(오래된 폰·카톡 안 브라우저)을 보기 위해
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "@/lib/firebase";

const seen = new Set<string>(); // 같은 오류는 한 방문에 한 번만
let sentCount = 0; // 무한 반복 오류가 기록을 도배하지 않게

function record(kind: string, message: string, stack: string) {
  const msg = String(message || "").slice(0, 500);
  if (!msg || seen.has(msg) || sentCount >= 5) return;
  seen.add(msg);
  sentCount++;
  addDoc(collection(db, "clientErrors"), {
    kind,
    message: msg,
    stack: String(stack || "").slice(0, 1500),
    url: location.pathname.slice(0, 200),
    ua: navigator.userAgent.slice(0, 300),
    at: serverTimestamp(),
  }).catch(() => { /* 기록 실패는 조용히 — 오류 기록 때문에 화면이 또 깨지면 안 된다 */ });
}

export function installClientErrorCapture() {
  window.addEventListener("error", (e) => record("error", e.message, e.error?.stack));
  window.addEventListener("unhandledrejection", (e) => {
    const r = e.reason;
    record("promise", r?.message || String(r), r?.stack);
  });
}
